export const imageAlignmentMap = {
	left: 'start',
	right: 'end',
};
